/**
 * @author Ivelin Ivanov.
 */
var DetailGppController = (function () {
    function DetailGppController(topic, settings, _) {
        var _this = this;
        this.topic = topic;
        this.settings = settings;
        this._ = _;
        this.comp = 'gppOnAssign';
        this.diffArray = [];
        this.paSiteVisibe = false;
        this.paSiteEditable = false;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.OPP_VERSION_5 = 5;
        // If the gppOnAssign object is not there...
        if (!this.topic.topic[this.comp]) {
            this.comp = 'gpp_live'; // Set as gpp_live - ie: the latest data
        }
        var contactEmail = this.topic.topic.version && this.topic.topic.version >= this.OPP_VERSION_5 ?
            this.topic.topic.contactEmail :
            _.get(this.topic.checksData, 'inboundInitial.inbound.incentiveInformation.incentiveDetail.createdBy');
        var oppVersion = _.get(this.topic.checksData, 'uiVersion', 1);
        this.getNewUIInfo = {
            uiVersion: oppVersion,
            email: contactEmail,
            bpCountry: function () {
                var countryShort;
                countryShort = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.country');
                return _this.topic.getCountryFullName(countryShort);
            },
            accountCountry: function () {
                var countryShort;
                countryShort = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.cmrCountryCode');
                return _this.topic.getCountryFullName(countryShort);
            },
            bpName: function () {
                var bpFirstName;
                var bpLastName;
                if (oppVersion && oppVersion <= _this.OPP_VERSION_4) {
                    bpFirstName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.bpFirstName');
                    bpLastName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.bpLastName');
                }
                else {
                    bpFirstName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.bpFirstName');
                    bpLastName = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.bp.bpLastName');
                }
                return bpFirstName + " " + bpLastName;
            },
            getSVISumbitDateName: function () {
                return _this.getNewUIInfo.uiVersion >= _this.OPP_VERSION_3
                    ? 'Submit Date:'
                    : 'Submit Date for CVR Eligibility:';
            },
            getAccountValue: function (accountName) {
                var generics = _.get(_this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail.generics');
                var accountObj = generics.find(function (generic) { return generic.label === accountName; });
                return accountObj ? accountObj.value : '';
            }
        };
    }
    DetailGppController.prototype.changePaVisible = function () {
        this.paSiteVisibe = !this.paSiteVisibe;
    };
    DetailGppController.prototype.isV4OrLess = function () {
        var version = this.topic.topic.version;
        return !version || version <= this.OPP_VERSION_4;
    };
    DetailGppController.$inject = ['topic', 'settings', '_'];
    return DetailGppController;
}());
var DetailGppComponent = (function () {
    function DetailGppComponent() {
        this.templateUrl = 'detail-general-gpp.html';
        this.controllerAs = 'vm';
        this.controller = DetailGppController;
    }
    return DetailGppComponent;
}());
angular
    .module('application')
    .component('detailGpp', new DetailGppComponent());

//# sourceMappingURL=detail.general.gpp.component.js.map
